/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useContext, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Field, Form, Formik } from "formik";
import { GlobalLoaderContext, GlobalAuthContext } from "store/context";
import Layout from "components/Layout";
import ContentCard from "components/ContentCard";
import Loader from "components/Loader";
import Row from "components/Grid/Row";
import Col from "components/Grid/Col";
import FormContainer from "components/FormContainer";
import { Button } from "components/index";
import InputField from "components/Form/InputField";
import Colors from "constants/Colors";
import { FitinsurAPI, MessageCenter } from "utils";
import { ButtonContainer, ButtonContent } from "./styles";
import Currencies from "./Currencies";
import Access from "constants/Access";

export default function EditProduct({ match }) {
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const history = useHistory();
  const formikRef = useRef(null);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  const [hasPermission, setHasPermission] = useState(true);
  const [idProduct, setIdProduct] = useState(match.params.idProduct);
  const [idPerson, setIdPerson] = useState(match.params.idPerson);
  const [productName, setProductName] = useState('');
  const [initial, setInitial] = useState({
    productName: '',
    productType: '',
  });
  const [currencies, setCurrencies] = useState([]);
  const [productCurrencies, setProductCurrencies] = useState([]);

  const getCurrencies = async () => {
    try {
      loading.start();
      fitinsur.setAuthToken(authContext.token);
      const response = await fitinsur.requestCurrenciesList(null)
        .then((res) => res.json());
      
      if (response.ret_code !== 200) 
        mc.error(response.ret_msg_details);

      const currenciesOptions = response.ret_value;

      setCurrencies(currenciesOptions);
      loading.stop();
    } catch (error) {
      console.log("Error fetch data: ", error);
      loading.stop();
      mc.error("An error happened, please try again.");
    }
  };

  const getProductsInfo = async () => {
    try {
      loading.start();
      fitinsur.setAuthToken(authContext.token);
      const response = await fitinsur.requestGetInfoProducts(idPerson, idProduct)
        .then((res) => res.json());
      
      if (response.ret_code !== 200) 
        mc.error(response.ret_msg_details);

      let {
        productName,
        productType,
        metadata
      } = response.ret_value;
      
      formikRef.current.values.productName = productName.description || '';
      formikRef.current.values.productType = productType || '';


      if(metadata.currencies && metadata.currencies.length){
        const currenciesData = metadata.currencies.map(currency => (
          {
            currencyCode: currency.currency_code,
            currencyId: currency.currency_id
          }
        ))

        setProductCurrencies(currenciesData);
      }
      
      setProductName(productName.description);
      loading.stop();
    } catch (error) {
      console.log("Error fetch data: ", error);
      loading.stop();
      mc.error("An error happened, please try again.");
    }
  };

  async function permissionAccess() {
    try {
      const response = await fitinsur
        .requestAccess("", idPerson ? "UPDATE" : "CREATE", Access.PERSON_EDIT, null, null, authContext.token)
        .then((response) => response.json())
      const hasPermission = response && response.ret_code === 200;
      setHasPermission(hasPermission);
    } catch (e) {
      setHasPermission(false);
    }
  }

  async function loadContent() {
    await permissionAccess(); 
    await getProductsInfo();
    await getCurrencies();
    loading.stop();
  }

  useEffect(() => {
    loadContent();
  }, [])

  useEffect(() => {
    setIdProduct(match.params.idProduct);
    setIdPerson(match.params.idPerson);
    loadContent();
  }, [match.params.idProduct])

  return (
    <Formik
      innerRef={formikRef}
      initialValues={initial}
      enableReinitialize={true}
      onSubmit={() => {}}
    >
      {({ values }) => (
        <Layout title={productName}>
          <ContentCard title="PRODUCT INFORMATION">
            <Form>
              <Row>
                <Col lg={4} md={4} sm={4} xs={12}>
                  <Field
                    name="productName"
                    label="Name"
                    component={InputField}
                    value={values.productName}
                    isRequired
                    disabled
                  />
                </Col>

                <Col lg={4} md={4} sm={4} xs={12}>
                  <Field
                    name="productType"
                    label="Product Type"
                    component={InputField}
                    values={values.productType}
                    isRequired
                    disabled
                  />
                </Col>
              </Row>
            {idProduct &&
              <Row style={{marginTop: '30px'}}>
                <Col lg={12} md={12} sm={12} xs={12}>
                  <FormContainer show={true} title="Currencies">
                    <Currencies
                      hasPermission={hasPermission}
                      productCurrencies={productCurrencies}
                      currencies={currencies}
                      idProduct={idProduct}
                      onSaveCurrency={async() => await getProductsInfo()}
                    />
                  </FormContainer>
                </Col>
              </Row>}
              <ButtonContainer>
                <ButtonContainer style={{ justifyContent: 'flex-start', alignItems: 'center', paddingBottom: '10px' }}>
                  <ButtonContent>
                    <Button forth onClick={() => history.goBack()} style={{ alignSelf: 'flex-start' }}> &lt; Back</Button>
                  </ButtonContent>
                </ButtonContainer>
              </ButtonContainer>
            {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
            </Form>
          </ContentCard>
        </Layout>
      )}
    </Formik>
  );
};
